import { HttpClient } from '@angular/common/http';
import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { ENV, URL_CIDADAO_REGISTROS } from '../../src/util/constants';

@Injectable({
  providedIn: 'root'
})
export class GlicoseService {

  constructor(private http: HttpClient, private auth: AuthenticateService) {

  }

  async recuperar() {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/glicose`, { headers: this.getHeadersToken() }).toPromise().then((result: any[]) => {
      return result;
    }).catch((error) => {
      if (ENV === 'DEV') {
        return [
          {
            numeroCartao: null,
            id: 130515,
            dataExame: "2023-12-31",
            resultado: 1,
            jejum: "Não",
          },
          {
            numeroCartao: null,
            id: 130516,
            dataExame: "2024-02-29",
            resultado: 2,
            jejum: "Não",
          },
        ];
      }
      return [];
    });
  }

  async excluir(data) {
    return this.http.delete(`${URL_CIDADAO_REGISTROS}rest/glicose/${data.id}`,
      { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async adicionar(prof) {
    let body = JSON.stringify({
      'dataExame': prof.dataExame,
      'resultado': prof.resultado,
      'jejum': prof.jejum ? 'S' : 'N'
    });

    return this.http.post(`${URL_CIDADAO_REGISTROS}rest/glicose`,
      body, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async edit(prof) {
    let body = JSON.stringify({
      'id': prof.id,
      'dataExame': prof.dataExame,
      'resultado': prof.resultado,
      'jejum': prof.jejum ? 'S' : 'N'
    });
    return this.http.put(`${URL_CIDADAO_REGISTROS}rest/glicose`,
      body, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {
    return {
      Authorization: this.auth.getAuthorizationToken(),
      'Content-Type': 'application/json'
    };
  }

  getHeadersJson() {
    return {
      'Content-Type': 'application/json'
    };
  }

}
